import Vue from 'vue';
import { mapGetters } from 'vuex';
import { REQUEST_PASSWORD_RESET } from 'src/store/types';
import TopBar from "components/TopBar.vue";
export default Vue.extend({
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    components: { TopBar },
    data() {
        return {
            email: null
        };
    },
    computed: {
        ...mapGetters([
            'hasRequestErrors', 'serverErrors', 'validationErrors'
        ])
    },
    methods: {
        doReset() {
            this.$validator.validateAll().then(() => {
                let el = document.querySelector('button.primary.submit.button');
                el?.classList.add('loading');
                this.$store.dispatch({
                    type: REQUEST_PASSWORD_RESET,
                    email: this.email
                })
                    .then(() => {
                    el?.classList.remove('loading');
                    if (this.hasRequestErrors === false) {
                        this.$router.push({ name: 'request-successful' });
                    }
                });
            }).catch(() => undefined);
        }
    }
});
